import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ProductSection } from './components/ProductSection';
import { BonusSection } from './components/BonusSection';
import { TransformationSection } from './components/TransformationSection';
import { DifferentialSection } from './components/DifferentialSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PurchaseSection } from './components/PurchaseSection';
import { FAQSection } from './components/FAQSection';
import { CommentsSection } from './components/CommentsSection';
import { ClosingSection } from './components/ClosingSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyOfferBar } from './components/StickyOfferBar';
export function App() {
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n: any = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '1270150181980590');
      f.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPointsSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <ProductSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <TransformationSection data-id="element-7" />
      <DifferentialSection data-id="element-8" />
      <PurchaseSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <CommentsSection data-id="element-11" />
      <TestimonialsSection data-id="element-12" />
      <ClosingSection data-id="element-13" />
      <SocialProofPopup data-id="element-14" />
      <StickyOfferBar data-id="element-15" />
    </div>;
}